import { useEffect, useState } from 'react';

/* Try to read device compass heading. Returns { heading, source }.
   source: 'compass' | 'gps' | 'unavailable'. */
export function useHeading(gpsHeading) {
  const [state, setState] = useState({ heading: null, source: 'unavailable' });

  useEffect(() => {
    let attached = false;
    let handler = null;

    const orient = (e) => {
      let h = null;
      if (e.webkitCompassHeading != null) h = e.webkitCompassHeading; // iOS
      else if (e.alpha != null && e.absolute) h = 360 - e.alpha;
      else if (e.alpha != null) h = 360 - e.alpha;
      if (h != null && !isNaN(h)) {
        setState({ heading: (h + 360) % 360, source: 'compass' });
      }
    };

    const attach = () => {
      if (attached) return;
      handler = orient;
      window.addEventListener('deviceorientationabsolute', handler, true);
      window.addEventListener('deviceorientation', handler, true);
      attached = true;
    };

    if (typeof DeviceOrientationEvent !== 'undefined' &&
        typeof DeviceOrientationEvent.requestPermission === 'function') {
      // iOS 13+ requires explicit permission — skip auto-request, will fallback to GPS.
      // We only attach if permission was already granted at higher level.
      attach();
    } else if (typeof window !== 'undefined' && 'DeviceOrientationEvent' in window) {
      attach();
    }

    return () => {
      if (handler) {
        window.removeEventListener('deviceorientationabsolute', handler, true);
        window.removeEventListener('deviceorientation', handler, true);
      }
    };
  }, []);

  if (state.source === 'compass' && state.heading != null) return state;
  if (gpsHeading != null && !isNaN(gpsHeading)) {
    return { heading: gpsHeading, source: 'gps' };
  }
  return { heading: null, source: 'unavailable' };
}
